<template>
    <div class="table-wrapper">
        <table :class="wrapperClass">
            <tr>
                <th colspan="2">{{ header }}</th>
            </tr>
            <tr v-for="planetPosition in orderedPlanetPositions">
                <td>{{ planetPosition.gate }}.{{ planetPosition.gateLine }}</td>
                <td>
                    <div>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <PlanetIcon x="0" y="0"
                                        :planet="planetPosition.planet"/>
                        </svg>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import constants from '@/constants';
    import PlanetIcon from "@/components/icon/PlanetIcon";

    export default {
        name: "NatalDesignTable",

        props: ['mode', 'planetPositions'],

        components: {
            PlanetIcon
        },

        computed: {
            wrapperClass() {
                return `${this.mode}-table`;
            },

            header() {
                return constants.modeNames.get(this.mode);
            },

            orderedPlanetPositions() {
                return this.filterAndOrderPlanetPositions(this.planetPositions);
            }
        },

        methods: {
            filterAndOrderPlanetPositions(planetPositions) {
                if (!planetPositions)
                    return [];

                let planets = constants.natalDesignPlanets;

                return planetPositions
                        .filter(p => planets.includes(p.planet))
                        .slice()
                        .sort((p1, p2) => planets.indexOf(p1.planet) - planets.indexOf(p2.planet));
            }
        }
    }
</script>
